<template>
  <div class="business-revenue main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr revenue-r">
          <!--<div class="notice"><i class="el-icon-s-shop"></i><span>通知：您收到了一笔新的付款...</span><button type="button" class="fr btn-more">查看更多 ></button></div>
          -->
          <div class="statistics">
            <ul class="revenue-data data-top" v-show="shopInfoOrder">
              <li class="today-trans">
                <div class="fl icon-money"></div>
                <div class="fl">
                  <p class="name">今日交易额（元）</p>
                  <p class="num" v-text="shopInfoOrder.nowDayOrderMoney">0.00</p>
                </div>
              </li>
              <li>
                <p class="name">今日订单</p>
                <p class="num" v-text="shopInfoOrder.nowDayOrderCount">0</p>
              </li>
              <li>
                <p class="name">本月订单</p>
                <p class="num" v-text="shopInfoOrder.nowMonthOrderCount">0</p>
              </li>
              <li>
                <p class="name">月营业额</p>
                <p class="num" v-text="shopInfoOrder.nowMonthOrderMoney">0.00</p>
              </li>
            </ul>
            <div class="statistics-tit">
              <span class="fl name">当月总收益：{{totalProfit}}</span>
              <div class="fr date-query">
                <span>收益查询</span>
                <el-date-picker
                        v-model="profitDate"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        @change="changeCurrentDate">
                </el-date-picker>
              </div>

            </div>
            <div class="revenue-part">
              <div id="shopRevenue" class="revenue-chart"></div>
            </div>
            <div class="statistics-tit mt10"><span class="name">收益统计</span></div>
            <div class="revenue-part part2">
              <ul class="revenue-data" v-if="shopInfo">
                <li>
                  <p class="name">可提现金额（元）</p>
                  <p class="num" v-text="shopInfo.shop.account"></p>
                </li>
                <li>
                  <p class="name">账户余额(元) <i class="el-icon-question"></i></p>
                  <p class="num" v-text="shopInfo.totalMoney"></p>
                </li>
                <li>
                  <p class="name">冻结余额(元) <i class="el-icon-question"></i></p>
                  <p class="num" v-text="shopInfo.noMoney"></p>
                </li>
              </ul>
              <!--<button type="button" class="btn-cash btn-main btn-small" @click="showCashMoney()">提现至余额</button>-->
            </div>
            <el-table
                    class="trans-list"
                    :data="transData"
                    :default-sort = "{prop: 'rate', order: 'descending'}"
                    :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
                    :header-cell-style="{
                  'background-color':'#EBF3EE',
                  'font-size':'14px',
                  'color':'#333333',
                  'height':'40px',
                  'padding':'0px',
                  'text-align':'left',
                  'padding-left':'20px',
                  'font-weight':'500'
              }"
                    :cell-style="{
                  'padding-left':'20px'
              }"
            >
              <el-table-column
                      prop="createTime"
                      label="交易时间"
                      width="180"
                      align="left"
              >

              </el-table-column>
              <el-table-column
                      prop="log"
                      label="交易类型"
                      width="300"
                      align="left">
              </el-table-column>
              <el-table-column
                      label="收支金额（元）"
                      align="left"
              >
                <template slot-scope="prop">
                  <span :class="prop.row.isAdd==1?'cell-red':''" v-text="prop.row.isAdd>0?'+'+prop.row.money:'-'+prop.row.money"></span>
                </template>
              </el-table-column>

            </el-table>
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="current"
                    layout=" prev, pager, next,total, jumper"
                    style="text-align: center;padding:20px;"
                    :hide-on-single-page="isHidePagination"
                    :total="total">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  //var echarts = require('echarts');
  import BusinessMenu from '../../components/setting/businessMenu'
  import {getShopMoneyInfo,getShopInfoForMe,getShopMoneyLogPage,addShopApply} from '../../api/shop'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
              shopInfoOrder:'',//店铺订单详细信息
              shopInfo:'',
              profitDate:new Date(),//日期查询
              transChart:[],//交易图表数据
              current:1,
              size:10,
              total:0,
              transData:[],
              isHidePagination:false,
              year:'',
              month:'',
              totalProfit:0
          }
      },
      components:{
          BusinessMenu
      },
      created () {
      },
      mounted(){
          let year=this.profitDate.getFullYear();
          let month=this.profitDate.getMonth()+1;
          this.getShopMoneyList(year,month);
          this.getShopInfo();
          this.getShopMoneyLogPageList();
      },
      methods:{
          showCashMoney(){
              this.$prompt('提现至余额', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputValidator: (val) => {
                      if( !val ){
                          return false;
                      }
                  },
                  inputErrorMessage: '余额不能为空'
              }).then(async ({ value }) => {
                  addShopApply(value).then(res=>{
                      this.getShopMoneyList(this.year,this.month);
                      this.$message({
                          type: 'success',
                          message: '提现成功'
                      });
                  })
              }).catch(() => {

              });
          },
          initShopChart(){
              let vm = this;
              let date = [];
              let data = [];
              let totalProfit=0;
              for (let i = 1; i < this.transChart.length; i++) {
                  date.push(this.transChart[i].day);
                  data.push(this.transChart[i].orderPrice);
                  totalProfit+=this.transChart[i].orderPrice
              }
              this.totalProfit=totalProfit;
              // 基于准备好的dom，初始化echarts实例
              let myChart = echarts.init(document.getElementById('shopRevenue'));
              myChart.setOption({
                  tooltip: {
                      trigger: 'axis',
                      position: function (pt) {
                          return [pt[0], '10%'];
                      }
                  },
                  title:{show:false},
                  toolbox: {
                      show:false,

                  },
                  grid:{
                      left:'5%',
                      top:'20%',
                      bottom:'10%',
                      right:'5%'
                  },
                  xAxis: {
                      type: 'category',
                      boundaryGap: false,
                      axisLine:{
                          show:false//显示刻度轴线
                      },
                      axisTick:{
                          show:false//显示刻度线
                      },
                      data: date
                  },
                  yAxis: {
                      type: 'value',
                      boundaryGap: [0, '100%'],
                      splitNumber:5,
                      axisLine:{
                          show:false//显示刻度轴线
                      },
                      axisTick:{
                          show:false//显示刻度线
                      }
                  },
                  /*dataZoom: [{
                      type: 'inside',
                      start: 0,
                      end: 10,
                      disabled:false
                  }, {
                      show:false,
                      start: 0,
                      end: 10,
                      handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                      handleSize: '80%',
                      handleStyle: {
                          color: '#fff',
                          shadowBlur: 3,
                          shadowColor: 'rgba(0, 0, 0, 0.6)',
                          shadowOffsetX: 2,
                          shadowOffsetY: 2
                      }
                  }],*/
                  series: [
                      {
                          name: '',
                          type: 'line',
                          smooth: true,
                          symbol: 'none',
                          sampling: 'average',
                          itemStyle: {
                              color: '#15B249'
                          },
                          areaStyle: {
                              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                  offset: 0,
                                  color: '#15B249'
                              }, {
                                  offset: 1,
                                  color: '#ffffff'
                              }])
                          },
                          data: data
                      }
                  ]
              });
          },
          getShopInfo(){
              getShopInfoForMe().then(res=>{
                  this.shopInfoOrder=res.data;
                  localStorage.setItem('shop',JSON.stringify(this.shopInfoOrder.shop));
              })
          },
          getShopMoneyList(year,month){
              this.year = year;
              this.month = month;
              getShopMoneyInfo({
                  year,
                  month
              }).then(res=>{
                  this.shopInfo=res.data;
                  this.transChart=res.data.orderPriceVos;
                  this.initShopChart();
                  this.getShopInfo();
              }).catch(err=>err);
          },
          changeCurrentDate(val){
              this.profitDate=new Date(val);
              let year=this.profitDate.getFullYear();
              let month=this.profitDate.getMonth()+1;
              this.getShopMoneyList(year,month);
          },
          getShopMoneyLogPageList(){
              getShopMoneyLogPage({
                  current:this.current,
                  size:this.size,
                  shopId:this.userInfo.shopId
              }).then(res=>{
                  this.total=res.data.total;
                  this.total<this.size?this.isHidePagination=true:this.isHidePagination=false;
                  this.transData=res.data.records
              })
          },
          handleCurrentChange(current){
              this.current=current;
              this.getShopMoneyLogPageList();
          },
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .revenue-r{
    width:1000px;
    .notice{
      font-size:16px;
      padding:22px 40px 30px 22px;
      background-color:#fff;
      i{margin-right:15px;font-size:22px;color:#FDB42B;}
      .btn-more{color:$main-color;}
    }
    .statistics{
      .statistics-tit {
        border-bottom:1px solid #E0E0E0;
        /*height:42px;*/
        line-height:42px;
        background: #ffffff;
        padding: 14px 30px 14px 40px;
        overflow: hidden;
        .name {
          font-size: 20px;
          vertical-align: middle;
        }
        .date-query{
          font-size:15px;
          &>span{color:$main-color;padding-right:10px;}
        }
      }
      .revenue-data{
        overflow: hidden;
        width:100%;
        display: table;
        background: #ffffff;
        &.data-top{
          padding:30px;
          margin-bottom:10px;
        }
        li{
          display: table-cell;
          vertical-align: middle;
          width:20%;
          &:first-child .num{font-size:40px;}
          &.today-trans{width:40%;}
          .icon-money{
            width:52px;
            height:52px;
            margin-right:20px;
            margin-top:10px;
            background:url("../../assets/images/icons/icon-money.png")no-repeat center;
          }
          .title{font-size:14px;color:#666666}
          .num{font-size:32px;
            font-weight:500;color:#333;}
        }
      }
      .revenue-part{
        padding:30px 40px;
        background-color: #ffffff;

        .revenue-chart{width:100%;height:285px;}
        .btn-cash{width:90px;height:36px;margin:50px 0 40px;}
      }
      /*.part2{padding-bottom:0;}*/
    }
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';

</style>
